export default "__VITE_ASSET__BLFTGzc$__"